export const state = {
  dashboardInfo: {
    importantMsgs: [],
    userCount: {
      current: 0
    },
    callCount: {
      today: 0,
      week: 0,
      month: 0
    },
    msgCount: {
      today: 0,
      week: 0,
      month: 0
    },
    helpMsgs: [],
    maintainer: {
      name: '',
      address: '',
      information: ''
    }
  }
}
export const mutations = {
  setDashboardInfo (state, response) {
    if (response.data['data'] == null) {
      response.data['data'] = [{}]
    }
    state.dashboardInfo = response.data['data'][0]
  }
}
export default {
  state,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/dashboardModules/dashboardMutation.js